
import { supabase } from '@/integrations/supabase/client';
import { WizardFormData } from '../types';

export const useStrategySubmit = () => {
  const createStrategy = async (formData: WizardFormData, providerId: string) => {
    if (!formData.strategy || !providerId) {
      return null;
    }

    // Ensure risk_level is within the valid range of 1-3
    const riskLevel = formData.strategy.risk_level || 1;
    const normalizedRiskLevel = Math.min(Math.max(riskLevel, 1), 3);

    const { data: strategyData, error: strategyError } = await supabase
      .from('strategy')
      .insert([{
        name: formData.strategy.name,
        description: formData.strategy.description,
        exchange: formData.strategy.exchange,
        currency: formData.strategy.currency,
        risk_level: normalizedRiskLevel,
        min_investment: formData.strategy.min_investment,
        active: formData.strategy.active || false,
        strategy_provider_id: providerId
      }])
      .select('id')
      .single();
      
    if (strategyError) {
      throw new Error(`Error creating strategy: ${strategyError.message}`);
    }
    
    return strategyData.id;
  };

  return { createStrategy };
};
